<template>
    <div class="banner">
        <b-carousel
            class="banner-carousel"
            id="carousel-1"
            v-model="slide"
            :interval="4000"
            controls
            indicators
        >
            <b-carousel-slide :img-src="require('@/assets/images/banner.png')">
            </b-carousel-slide>
        </b-carousel>

        <b-container class="max-width">
            <div class="msg">
                <div class="msg-title--l">安博腾生物科技有限公司</div>
                <div class="msg-content">
                    深圳市安博腾生物科技有限公司成立于2018年06月06日，经营范围包括生物制品的技术开发；生物科技产品的技术开发；新能源的技术开发；实验室仪器及其耗材、检测仪器及其耗材的销售；化工产品(不含危险化学品、易制毒化学品)、纤维材料、机械设备的研发和销售；实验设备的上门维修及技术咨询服务；投资兴办实业(具体项目另行申报)；国内贸易;经营进出口业务。(法律、行政法规、国务院决定规定在登记前须经批准的项目除外）
                </div>
            </div>
        </b-container>
        
    </div>
</template>

<script>
export default {
    data() {
        return {
            slide: 0
        };
    }
};
</script>

<style lang="less">
@import "./index.less";
</style>
